import { buildLotAltText } from "../../lib/lotAltText";

type Props = {
  lot: Catalog.Lot;
  index?: number;
};

export default function LotThumbnail(props: Props) {
  const image = props.lot.image;
  const { index = 999 } = props;
  const isAboveFold = index < 3;

  const alt = buildLotAltText(
    props.lot.title,
    props.lot.artist_name,
    props.lot.artist_lifespan,
    props.lot.object_type,
    props.lot.year
  );

  return (
    <div className="image">
      <div className="image-wrapper">
        {image && (
          <img
            src={image.small}
            alt={alt}
            width={image.width}
            height={image.height}
            loading={isAboveFold ? "eager" : "lazy"}
          />
        )}
      </div>
    </div>
  );
}
